import React from 'react'

const UserIcon = ({ size = 16, className, ...props }) => {
    return (
        <svg 
            {...props} 
            className={className}
            width={size} 
            height={size} 
            fill="currentColor" 
            viewBox="0 0 20 20"
        >
            <path 
                fillRule="evenodd" 
                d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" 
                clipRule="evenodd" 
            />
        </svg>
    )
}

export default UserIcon
